import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface ICarouselPayload {
  lang: string;
}

export const carouselSlice = createApi({
  reducerPath: 'carousel',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getCarousel'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Carousel'],
  endpoints: (builder) => ({
    getCarousel: builder.query<IAnyResponse, ICarouselPayload>({
      query: (payload) => ({
        url: `/carousel`,
        method: 'GET'
      })
    })
  })
});

export const { useGetCarouselQuery } = carouselSlice;
